// extracted by mini-css-extract-plugin
export default {"priceList":"style_priceList__J+0HG","priceListHeader":"style_priceListHeader__1IWXk","priceListItem":"style_priceListItem__y2PMA"};